import { mapCheckToPlaybook } from '../playbooks/checkMap';
import { collectManualChecks } from '../playbooks/manualChecks';
import { sortGapsByPriority } from '../tui/menu';
import { PUBLIC_VERIFY_COMMAND } from '../contracts/commands';
import type { CliScanArtifact } from '../types';

export function generateLaunchPlaybook(artifact: CliScanArtifact): string {
  const lines: string[] = [];

  lines.push('# VibeRaven launch playbook', '');
  lines.push(`Generated from scan at ${artifact.scannedAt}. Work top to bottom.`, '');

  lines.push('## Repo fixes (agent code)', '');
  const repoGaps = sortGapsByPriority(artifact.gaps);
  if (repoGaps.length === 0) {
    lines.push('_No repo-code gaps found._', '');
  } else {
    for (const gap of repoGaps) {
      lines.push(`- [ ] ${gap.title} — \`viberaven prompt --gap ${gap.id}\``);
    }
    lines.push('');
  }

  lines.push('## Provider setup (human + agent)', '');
  const manuals = collectManualChecks(artifact);
  if (manuals.length === 0) {
    lines.push('_No provider dashboard steps identified._', '');
  } else {
    for (const item of manuals) {
      const provider = mapCheckToPlaybook(item.check);
      lines.push(
        `- [ ] ${item.check.label} (${item.areaLabel}) — \`viberaven guide ${provider} --step 1\``
      );
    }
    lines.push('');
  }

  lines.push('## Agent loop', '');
  lines.push('1. Read `.viberaven/agent-tasklist.md` for the current production gate.');
  lines.push('2. `viberaven next --json`');
  lines.push('3. Fix repo or run `viberaven guide <provider>`');
  lines.push(`4. Run \`${PUBLIC_VERIFY_COMMAND}\` to refresh the gate and \`.viberaven/agent-tasklist.md\`.`);
  lines.push('');

  return `${lines.join('\n')}\n`;
}
